import Buttons from "views/Components/Buttons.js";
import Calendar from "views/Calendar/Calendar.js";
import Charts from "views/Charts/Charts.js";
import Dashboard from "views/Dashboard/Dashboard.js";
import ErrorPage from "views/Pages/ErrorPage.js";
import ExtendedForms from "views/Forms/ExtendedForms.js";
import ExtendedTables from "views/Tables/ExtendedTables.js";
import FullScreenMap from "views/Maps/FullScreenMap.js";
import GoogleMaps from "views/Maps/GoogleMaps.js";
import GridSystem from "views/Components/GridSystem.js";
import Icons from "views/Components/Icons.js";
import LockScreenPage from "views/Pages/LockScreenPage.js";
import LoginPage from "views/Pages/LoginPage.js";
import Notifications from "views/Components/Notifications.js";
import Panels from "views/Components/Panels.js";
import PricingPage from "views/Pages/PricingPage.js";
import RTLSupport from "views/Pages/RTLSupport.js";
import ReactTables from "views/Tables/ReactTables.js";
import RegisterPage from "views/Pages/RegisterPage.js";
import ForgotPasswordPage from "views/Pages/ForgotPasswordPage.js";
import ResetPasswordPage from "views/Pages/ResetPasswordPage.js";
import RegularForms from "views/Forms/RegularForms.js";
import RegularTables from "views/Tables/RegularTables.js";
import SweetAlert from "views/Components/SweetAlert.js";
import TimelinePage from "views/Pages/Timeline.js";
import Typography from "views/Components/Typography.js";
import UserProfile from "views/Pages/UserProfile.js";
import ValidationForms from "views/Forms/ValidationForms.js";
import VectorMap from "views/Maps/VectorMap.js";
import Widgets from "views/Widgets/Widgets.js";
import Wizard from "views/Forms/Wizard.js";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DateRange from "@material-ui/icons/DateRange";
import GridOn from "@material-ui/icons/GridOn";
import Image from "@material-ui/icons/Image";
import Place from "@material-ui/icons/Place";
import Timeline from "@material-ui/icons/Timeline";
import WidgetsIcon from "@material-ui/icons/Widgets";

var dashRoutes = [
    {
        path: "/dashboard",
        name: "Dashboard",
        protected: "true",
        rtlName: "لوحة القيادة",
        icon: DashboardIcon,
        component: Dashboard,
        layout: "/admin",
    },
    {
        collapse: true,
        name: "Pages",
        protected: "false",
        rtlName: "صفحات",
        icon: Image,
        state: "pageCollapse",
        views: [
            {
                path: "/pricing-page",
                name: "Pricing Page",
                protected: "false",
                rtlName: "عالتسعير",
                mini: "PP",
                rtlMini: "ع",
                component: PricingPage,
                layout: "/auth",
            },
            {
                path: "/rtl-support-page",
                name: "RTL Support",
                protected: "false",
                rtlName: "صودعم رتل",
                mini: "RS",
                rtlMini: "صو",
                component: RTLSupport,
                layout: "/rtl",
            },
            {
                path: "/timeline-page",
                name: "Timeline Page",
                protected: "false",
                rtlName: "تيالجدول الزمني",
                mini: "T",
                rtlMini: "تي",
                component: TimelinePage,
                layout: "/admin",
            },
            {
                path: "/login-page",
                name: "Quizhouse Admin Login Page",
                protected: "false",
                rtlName: "هعذاتسجيل الدخول",
                mini: "L",
                rtlMini: "هعذا",
                component: LoginPage,
                layout: "/auth",
            },
            {
                path: "/register-page",
                name: "Register Page",
                protected: "false",
                rtlName: "تسجيل",
                mini: "R",
                rtlMini: "صع",
                component: RegisterPage,
                layout: "/auth",
            },
            {
                path: "/forgot-password",
                name: "Forgot Password",
                rtlName: "نسيت كلمة المرور",
                protected: "false",
                mini: "F",
                rtlMini: "صع",
                component: ForgotPasswordPage,
                layout: "/auth",
            },
            {
                path: "/reset-password",
                name: "Reset Password",
                rtlName: "إعادة تعيين كلمة المرور",
                protected: "false",
                mini: "R",
                rtlMini: "صع",
                component: ResetPasswordPage,
                layout: "/auth",
            },
            {
                path: "/lock-screen-page",
                name: "Lock Screen Page",
                protected: "false",
                rtlName: "اقفل الشاشة",
                mini: "LS",
                rtlMini: "هذاع",
                component: LockScreenPage,
                layout: "/auth",
            },
            {
                path: "/user-page",
                name: "User Profile",
                protected: "false",
                rtlName: "ملف تعريفي للمستخدم",
                mini: "UP",
                rtlMini: "شع",
                component: UserProfile,
                layout: "/admin",
            },
            {
                path: "/error-page",
                name: "Error Page",
                protected: "false",
                rtlName: "صفحة الخطأ",
                mini: "E",
                rtlMini: "البريد",
                component: ErrorPage,
                layout: "/auth",
            },
        ],
    },
    {
        collapse: true,
        name: "Components",
        protected: "false",
        rtlName: "المكونات",
        icon: Apps,
        state: "componentsCollapse",
        views: [
            {
                collapse: true,
                name: "Multi Level Collapse",
                protected: "false",
                rtlName: "انهيار متعدد المستويات",
                mini: "MC",
                rtlMini: "ر",
                state: "multiCollapse",
                views: [
                    {
                        path: "#sample-path",
                        name: "Example",
                        protected: "false",
                        rtlName: "مثال",
                        mini: "E",
                        rtlMini: "ه",
                        component: () => { },
                        layout: "#sample-layout",
                    },
                ],
            },
            {
                path: "/buttons",
                name: "Buttons",
                protected: "false",
                rtlName: "وصفت",
                mini: "B",
                rtlMini: "ب",
                component: Buttons,
                layout: "/admin",
            },
            {
                path: "/grid-system",
                name: "Grid System",
                protected: "false",
                rtlName: "نظام الشبكة",
                mini: "GS",
                rtlMini: "زو",
                component: GridSystem,
                layout: "/admin",
            },
            {
                path: "/panels",
                name: "Panels",
                protected: "false",
                rtlName: "لوحات",
                mini: "P",
                rtlMini: "ع",
                component: Panels,
                layout: "/admin",
            },
            {
                path: "/sweet-alert",
                name: "Sweet Alert",
                protected: "false",
                rtlName: "الحلو تنبيه",
                mini: "SA",
                rtlMini: "ومن",
                component: SweetAlert,
                layout: "/admin",
            },
            {
                path: "/notifications",
                name: "Notifications",
                protected: "false",
                rtlName: "إخطارات",
                mini: "N",
                rtlMini: "ن",
                component: Notifications,
                layout: "/admin",
            },
            {
                path: "/icons",
                name: "Icons",
                protected: "false",
                rtlName: "الرموز",
                mini: "I",
                rtlMini: "و",
                component: Icons,
                layout: "/admin",
            },
            {
                path: "/typography",
                name: "Typography",
                protected: "false",
                rtlName: "طباعة",
                mini: "T",
                rtlMini: "ر",
                component: Typography,
                layout: "/admin",
            },
        ],
    },
    {
        collapse: true,
        name: "Forms",
        protected: "false",
        rtlName: "إستمارات",
        icon: "content_paste",
        state: "formsCollapse",
        views: [
            {
                path: "/regular-forms",
                name: "Regular Forms",
                protected: "false",
                rtlName: "أشكال عادية",
                mini: "RF",
                rtlMini: "صو",
                component: RegularForms,
                layout: "/admin",
            },
            {
                path: "/extended-forms",
                name: "Extended Forms",
                protected: "false",
                rtlName: "نماذج موسعة",
                mini: "EF",
                rtlMini: "هوو",
                component: ExtendedForms,
                layout: "/admin",
            },
            {
                path: "/validation-forms",
                name: "Validation Forms",
                protected: "false",
                rtlName: "نماذج التحقق من الصحة",
                mini: "VF",
                rtlMini: "تو",
                component: ValidationForms,
                layout: "/admin",
            },
            {
                path: "/wizard",
                name: "Wizard",
                protected: "false",
                rtlName: "ساحر",
                mini: "W",
                rtlMini: "ث",
                component: Wizard,
                layout: "/admin",
            },
        ],
    },
    {
        collapse: true,
        name: "Tables",
        protected: "false",
        rtlName: "الجداول",
        icon: GridOn,
        state: "tablesCollapse",
        views: [
            {
                path: "/regular-tables",
                name: "Regular Tables",
                protected: "false",
                rtlName: "طاولات عادية",
                mini: "RT",
                rtlMini: "صر",
                component: RegularTables,
                layout: "/admin",
            },
            {
                path: "/extended-tables",
                name: "Extended Tables",
                protected: "false",
                rtlName: "جداول ممتدة",
                mini: "ET",
                rtlMini: "هور",
                component: ExtendedTables,
                layout: "/admin",
            },
            {
                path: "/react-tables",
                name: "React Tables",
                protected: "false",
                rtlName: "رد فعل الطاولة",
                mini: "RT",
                rtlMini: "در",
                component: ReactTables,
                layout: "/admin",
            },
        ],
    },
    {
        collapse: true,
        name: "Maps",
        protected: "false",
        rtlName: "خرائط",
        icon: Place,
        state: "mapsCollapse",
        views: [
            {
                path: "/google-maps",
                name: "Google Maps",
                protected: "false",
                rtlName: "خرائط جوجل",
                mini: "GM",
                rtlMini: "زم",
                component: GoogleMaps,
                layout: "/admin",
            },
            {
                path: "/full-screen-maps",
                name: "Full Screen Map",
                protected: "false",
                rtlName: "خريطة كاملة الشاشة",
                mini: "FSM",
                rtlMini: "ووم",
                component: FullScreenMap,
                layout: "/admin",
            },
            {
                path: "/vector-maps",
                name: "Vector Map",
                protected: "false",
                rtlName: "خريطة المتجه",
                mini: "VM",
                rtlMini: "تم",
                component: VectorMap,
                layout: "/admin",
            },
        ],
    },
    {
        path: "/widgets",
        name: "Widgets",
        protected: "false",
        rtlName: "الحاجيات",
        icon: WidgetsIcon,
        component: Widgets,
        layout: "/admin",
    },
    {
        path: "/charts",
        name: "Charts",
        protected: "false",
        rtlName: "الرسوم البيانية",
        icon: Timeline,
        component: Charts,
        layout: "/admin",
    },
    {
        path: "/calendar",
        name: "Calendar",
        protected: "false",
        rtlName: "التقويم",
        icon: DateRange,
        component: Calendar,
        layout: "/admin",
    },
];
export default dashRoutes;
